import React from "react";
import AdminAddForm from "../Components/AddLiterature/AdminAddForm";
import Header from "../Components/Utilities/Header";

function AdminAddLiterature() {
  return (
    <>
      <div id="addLiterature">
        <Header />
        <AdminAddForm />
      </div>
    </>
  );
}

export default AdminAddLiterature;
